module.exports = __webpack_public_path__ + "img/as.b1317bb5.svg";